// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"159":"6f9111dc","453":"145d6d1b","782":"007f2631"}[chunkId] + ".chunk.js";
};